import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { API, Auth } from "aws-amplify";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../utils/reinstallments";
import { calReportAging } from "../../utils/calReportAging";
import { pad } from "utils/getLocalDateTime";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function DebtorPayment({ selectToday }) {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [dataDebtor, setDataDebtor] = useState([]);

  useEffect(() => {
    if (dataDebtor.length > 0) {
      const getExportId = document.getElementById(
        "export-excel-debtor-payment"
      );
      getExportId.click();
    }
  }, [dataDebtor]);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickAging = async () => {
    try {
      setLoading(true);

      let data = {};
      let localCount = 0;
      let lastItem = null;
      let keepLoan = [];

      do {
        data = await API.get("MoneyHubAdmin", "/loan/debtorPayment", {
          queryStringParameters: {
            selectDate: selectToday,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = data?.lastItem;
        localCount += data?.items.length;
        keepLoan.push(...data?.items);
        setCount(localCount);
      } while (lastItem);

      setDataDebtor(keepLoan);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
    }
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    var filled = { fgColor: { rgb: "FFFFFF" } };
    let style = { borders, font: { sz: 14 }, alignment: "right", fill: filled };

    for (let i = 0; i < data.length; i++) {
      const debtorPayment = data[i];

      result.push([
        { value: `${debtorPayment?.TransactionNumber}`, style },
        { value: `${debtorPayment?.Cardno}`, style },
        { value: debtorPayment.Payment, style },
        { value: debtorPayment.PaymentDate, style },
        { value: debtorPayment.OSBalance, style },
        { value: debtorPayment.Bank, style },
        { value: debtorPayment.Bucket, style },
        { value: debtorPayment.InstallmentNumber, style },
        { value: debtorPayment.Principle, style },
        { value: debtorPayment.InterestAmount, style },
        { value: debtorPayment.CollectedInterest, style },
        { value: debtorPayment.sendDebtorDate, style },
        { value: debtorPayment.Current, style },
        { value: debtorPayment.Block || "", style },
        {
          value: debtorPayment?.DPD || "",
          style,
        },
        {
          value: debtorPayment?.Cycle || "",
          style,
        },
        {
          value: debtorPayment?.Bucket || "",
          style,
        },
        { value: debtorPayment.xDay, style },
        { value: debtorPayment.x30Day, style },
        { value: debtorPayment.x60Day, style },
        { value: debtorPayment.x90Day, style },
        { value: debtorPayment.x120Day, style },
        { value: debtorPayment.x150Day, style },
        { value: debtorPayment.x180Day, style },
        { value: debtorPayment.x210Day, style },
        { value: debtorPayment.totalDue, style },
      ]);
    }

    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "TransactionNumber",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Cardno",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Payment",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "PaymentDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "OSBalance",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Bank",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Bucket",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "InstallmentNumber",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Principle",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "InterestAmount",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "CollectedInterest",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "sendDebtorDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Current",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Block",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "DPD",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Cycle",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Bucket",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "xDay",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x30Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x60Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x90Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x120Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x150Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x180Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x210Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "TotalDue",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
      ],
      data: createDataWithStyle(dataDebtor),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`REPORT_DEBTOR_PAYMENT_${format(
          new Date(selectToday),
          "yyyy-MM-dd"
        )}`}
        element={<button id="export-excel-debtor-payment" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="DebtorPayment"></ExcelSheet>
      </ExcelFile>
      <button
        disabled={loading}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
        onClick={onClickAging}
      >
        {loading && (
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx={12}
              cy={12}
              r={10}
              stroke="currentColor"
              strokeWidth={4}
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        {count > 0 && `(${count})`} DebtorPayment Report
      </button>
    </div>
  );
}

export default DebtorPayment;
